<ridango-page-content-wrapper>
    <div class="shopping-cart-confirm-payment">
        <h2 class="title">{{ 'CART_SUMMARY_YOUR_PRICE' | translate }}</h2>
        <p class="price">
            {{ (cart$ | async)?.total_sum | moneyFormat }} {{ appStartupService.getCurrency() | translate }}
        </p>

        <div class="summary-module-area__btn">
            <ng-container [ngSwitch]="(selectedPaymentMethod$ | async)?.code">
                <ng-container *ngSwitchCase="paymentChannelCode.ADYEN">
                    <button
                        class="btn btn--maximal btn--primary"
                        [routerLink]="'/adyen' | localize"
                        [disabled]="(termsAgreed$ | async) === false || (selectedPaymentMethod$ | async) === null"
                        (click)="confirmAdyen()">
                        {{ 'BUTTON_CONFIRM_PAYMENT' | translate }}
                    </button>
                </ng-container>

                <ng-container *ngSwitchCase="paymentChannelCode.SWISH">
                    <button
                        class="btn btn--maximal btn--primary"
                        [disabled]="(termsAgreed$ | async) === false || (selectedPaymentMethod$ | async) === null"
                        (click)="confirmSwish()">
                        {{ 'BUTTON_CONFIRM_PAYMENT' | translate }}
                    </button>
                </ng-container>

                <ng-container *ngSwitchCase="paymentChannelCode.PAYMENT_PORTAL">
                    <button
                        class="btn btn--maximal btn--primary"
                        [disabled]="(termsAgreed$ | async) === false || (selectedPaymentMethod$ | async) === null"
                        (click)="confirmPaymentPortal()">
                        {{ 'BUTTON_CONFIRM_PAYMENT' | translate }}
                    </button>
                </ng-container>

                <ng-container *ngSwitchCase="paymentChannelCode.INVOICE">
                    <button
                        class="btn btn--maximal btn--primary"
                        [disabled]="invoiceRequested"
                        (click)="confirmInvoice()">
                        {{ 'BUTTON_CONFIRM_PAYMENT' | translate }}
                    </button>
                </ng-container>

                <ng-container *ngSwitchDefault>
                    <button
                        class="btn btn--maximal btn--primary"
                        *ngIf="(cart$ | async)?.shopping_cart_id"
                        [disabled]="(termsAgreed$ | async) === false || (selectedPaymentMethod$ | async) === null"
                        (click)="confirmCart()">
                        {{ 'BUTTON_CONFIRM_PAYMENT' | translate }}
                    </button>
                </ng-container>
            </ng-container>
        </div>

        <div class="summary-module-area__btn margin-top-30">
            <ridango-ui-back-button class="flex justify-center" [showArrow]="false" (onBack)="cancelCart()">
                {{ 'PURCHASE_SUMMARY_CANCEL_LINK' | translate }}
            </ridango-ui-back-button>
        </div>
    </div>
</ridango-page-content-wrapper>

<rwidget-navigate-away-modal
    [showNavigationModal]="showNavigationModal"
    (onConfirmNavigation)="onConfirmNavigationModal()"
    (onCancelNavigation)="onCloseNavigationModal()"></rwidget-navigate-away-modal>
